import React from "react";
import "animate.css";
import "./Home.css";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

function Home() {
  useEffect(() => {
    AOS.init({
      duration: 1200, // Durasi animasi 1000ms
      easing: "ease-in-out",
      once: false, // animasi bisa muncul saat scroll naik & turun
      mirror: true, // animasi juga muncul saat scroll ke atas
    });
    AOS.refresh();
  }, []);

  const servicesData = [
    { title: "Pengembangan Produk", image: "/images/service1.png" },
    {
      title: "Pembuatan Prototipe dan Sampel Produk",
      image: "/images/service2.png",
    },
    { title: "Manufaktur Merek Pribadi", image: "/images/service3.png" },
    { title: "Desain Kemasan Khusus", image: "/images/service4.png" },
    { title: "Pengendalian Mutu dan Kepatuhan", image: "/images/service5.png" },
    { title: "Dukungan Logistik dan Ekspor", image: "/images/service6.png" },
  ];

  return (
    <div className="page-container">
      {/* HERO SECTION */}
      <div
        className="hero-wrapper animate__animated animate__fadeIn"
        style={{ backgroundImage: `url("/images/bed.png")` }}
      >
        <div className="hero-content-idn text-white text-center">
          <div className="container">
            <h1 className="display-3 fw-bold mb-3 animate__animated animate__fadeInUp animate__delay-1s welcome">
              SELAMAT DATANG
            </h1>
            <p className="lead fs-3 animate__animated animate__fadeInUp animate__delay-2s comfort">
              Membawa Kenyamanan. Mewujudkan Kebahagiaan.
            </p>
          </div>
        </div>
      </div>

      {/* OUR SERVICES */}
      <div
        id="services"
        className="container py-5 section-fade mt-5"
        data-aos="fade-up"
      >
        <h2 className="section-title-product text-center">
          LAYANAN KAMI sebagai OEM
        </h2>
        <div className="row g-4">
          {servicesData.map((service, idx) => (
            <div
              className="col-md-4"
              key={idx}
              data-aos="fade-up"
              data-aos-delay={idx * 100}
            >
              <div
                className="service-card position-relative overflow-hidden rounded"
                style={{ backgroundImage: `url(${service.image})` }}
              >
                <div className="service-overlay d-flex align-items-center justify-content-center text-center">
                  <h5 className="text-white fw-bold px-2 mb-0">
                    {service.title}
                  </h5>
                </div>
              </div>
            </div>
          ))}
        </div>
        <br />
        <h2 className="section-title-product text-center fs-3 tagline-service">
          Build to Power Your Brand
        </h2>
      </div>

      {/* WHO WE ARE */}
      <div
        className="container-fluid text-white py-5 section-fade"
        data-aos="fade-in"
        style={{
          backgroundImage: 'url("/images/BG - HOME PAGE.png")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            zIndex: 0,
          }}
        />
        <div
          className="container d-flex flex-column flex-md-row align-items-center justify-content-between"
          style={{ position: "relative", zIndex: 1 }}
        >
          <div className="mb-4 mb-md-0" style={{ maxWidth: "600px" }}>
            <h2 className="who-title">SIAPA KAMI</h2>
            <p className="who-text">
              Kami adalah produsen furnitur dan OEM yang berbasis di <br />{" "}
              Indonesia, yang mengkhususkan diri dalam produksi kasur, <br />{" "}
              bantal, dan berbagai produk custom berkualitas tinggi.
            </p>
            <p className="who-text">
              Dengan komitmen kuat terhadap kualitas dan <br /> ketepatan waktu,
              kami membantu klien menciptakan solusi furnitur bermerek <br />{" "}
              yang disesuaikan dengan kebutuhan pasar mereka.
            </p>
            <Link
              to="/about#company-profile"
              className="btn btn-light rounded-pill px-4 mt-2"
            >
              Selengkapnya
            </Link>
          </div>
        </div>
      </div>

      {/* PROJECT HIGHLIGHTS */}
      <div
        className="project-highlights-section text-center section-fade"
        data-aos="zoom-in"
      >
        <h2 className="highlight-title">Sorotan Proyek</h2>
        <div className="highlight-divider"></div>
        <p className="highlight-description">
          Kami telah berhasil menyelesaikan berbagai proyek produksi custom{" "}
          <br />
          untuk perusahaan swasta dan institusi pemerintahan
        </p>
        <div className="highlight-divider"></div>

        {/* Lingkaran dengan ikon handshake + journal + tombol */}
        <div className="highlight-circle mx-auto mt-4 d-flex flex-column align-items-center justify-content-center">
          {/* Logo handshake di atas */}
          <img
            src="/images/handshake.png"
            alt="Handshake"
            className="highlight-handshake mb-2"
          />

          {/* Ikon journal yang sudah ada */}
          <i
            className="bi bi-journal-check text-white mb-2"
            style={{ fontSize: "2.5rem" }}
          ></i>

          {/* Tombol */}
          <button className="btn btn-dark rounded-pill px-4 py-1">
            Selengkapnya
          </button>
        </div>
      </div>

      {/* FOOTER SECTION */}
      <div
        className="footer-section text-white section-fade"
        style={{ backgroundColor: "#754c24" }}
        data-aos="fade-up"
      >
        <div className="container-fluid px-0">
          <div className="row g-0">
            <div
              className="col-md-3 d-flex align-items-center justify-content-center"
              style={{ backgroundColor: "#5c3e1c", position: "relative" }}
            >
              <img
                src="/images/dotwall.jpg"
                alt="FORMEB Logo"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  zIndex: 0,
                }}
              />
              <div
                className="text-center py-4 px-3"
                style={{ zIndex: 1, position: "relative" }}
              >
                <img
                  src="/images/logo.png"
                  alt="FORMEB Logo"
                  style={{ maxWidth: "350px" }}
                />
                <p className="footer-tagline mt-2 fst-italic text-white">
                  Foremost Living Style
                </p>
              </div>
            </div>

            <div className="col-md-9 px-4 py-5">
              <div className="row text-start">
                <div className="col-md-4 mb-4 mb-md-0 border-end border-light px-4">
                  <h5 className="footer-title text-white">PRODUK</h5>
                  <ul className="list-unstyled footer-links">
                    <li>Kasur</li>
                    <li>Bantal</li>
                    <li>Busa</li>
                  </ul>
                </div>
                <div className="col-md-4 mb-4 mb-md-0 border-end border-light px-4">
                  <h5 className="footer-title text-white">TENTANG KAMI</h5>
                  <ul className="list-unstyled footer-links">
                    <li>
                      <Link
                        to="/about-id#company-profile"
                        className="text-white text-decoration-none"
                      >
                        Profil Perusahaan
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/products#services"
                        className="text-white text-decoration-none"
                      >
                        Servis
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/products#services"
                        className="text-white text-decoration-none"
                      >
                        Proyek Kami
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/products#services"
                        className="text-white text-decoration-none"
                      >
                        Karir
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="col-md-4 ps-4">
                  <h5 className="footer-title text-white">KONTAK</h5>
                  <ul className="list-unstyled footer-links">
                    <li>
                      <Link
                        to="/contact-id"
                        className="text-white text-decoration-none"
                      >
                        Kontak Kami
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/contact-id"
                        className="text-white text-decoration-none"
                      >
                        Lokasi Kami
                      </Link>
                    </li>
                    <li className="mt-2">
                      <a
                        href="mailto:xxxxxx@gmail.com"
                        className="text-white me-3"
                      >
                        <i className="bi bi-envelope"></i>
                      </a>
                      <a
                        href="https://www.linkedin.com/company/pt-foremost-mebel-indonesia/posts/?feedView=all"
                        className="text-white"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="bi bi-linkedin"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <hr className="text-light my-4" />
              <div className="row">
                <div className="col-md-6">
                  <p className="footer-email fw-bold text-white">
                    contact@formeb.id
                  </p>
                  <address className="footer-address text-white mt-2">
                    PT. FOREMOST MEBEL INDONESIA
                    <br />
                    Jl. Gemilang, RT.002/RW.003, Tlajung Udik,
                    <br />
                    Kec. Gn. Putri, Kabupaten Bogor, Jawa Barat 16963
                  </address>
                </div>
              </div>
              <div className="d-flex justify-content-end mt-4 small text-light">
                ©2025 Foremost Mebel Indonesia. All Rights Reserved.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
